import { render, staticRenderFns } from "./DeadlineDate.vue?vue&type=template&id=be21cc42"
import script from "./DeadlineDate.vue?vue&type=script&lang=js"
export * from "./DeadlineDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports